import React, { memo, useEffect } from 'react';
import useLiveEvents from '../../telemetry/useLiveEvents';

function TelemetryToasts() {
  var live = useLiveEvents();

  useEffect(
    function () {
      if (!live.toasts.length) return undefined;
      var latest = live.toasts[live.toasts.length - 1];
      var timer = setTimeout(function () {
        live.dismissToast(latest.id);
      }, 3200);
      return function () {
        clearTimeout(timer);
      };
    },
    // Intentionally only react to toast list identity/length
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [live.toasts]
  );

  if (!live.toasts.length) return null;

  return (
    <div className="telemetry-toasts" aria-live="polite">
      {live.toasts.map(function (toast) {
        return (
          <div key={toast.id} className="telemetry-toast" role="status">
            <span>{toast.message}</span>
            <button
              type="button"
              className="telemetry-toast__close"
              aria-label="Dismiss"
              onClick={function () {
                live.dismissToast(toast.id);
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default memo(TelemetryToasts);
